export default {
  card_shadow_2dp: '0 0 2px 0 rgba(159, 165, 175, 0.5)',
  card_shadow_4dp: '0px -1px 2px rgba(69, 74, 83, 0.08), 0px 4px 4px rgba(159, 165, 175, 0.5)',
  card_shadow_8dp: '0px -1px 2px rgba(0, 0, 0, 0.08), 0px 8px 8px rgba(159, 165, 175, 0.5)',
  card_shadow_16dp: '0px -1px 4px rgba(69, 74, 83, 0.08), 0px 16px 16px rgba(159, 165, 175, 0.5)',
  card_shadow_24dp: '0px -1px 4px rgba(69, 74, 83, 0.08), 0px 24px 24px rgba(159, 165, 175, 0.5)',
  card_shadow_32dp: '0px -1px 4px rgba(69, 74, 83, 0.08), 0px 32px 32px rgba(159, 165, 175, 0.5)',
}
